import { render, staticRenderFns } from "./TextAreaStyled.vue?vue&type=template&id=4445dbb2&scoped=true"
import script from "./TextAreaStyled.vue?vue&type=script&lang=js"
export * from "./TextAreaStyled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4445dbb2",
  null
  
)

export default component.exports